<template>
    <div class="wrap">
      <!-- 새로 생성하는 룩북 아이템 상품 엑셀 멀티 등록 -->
        <div class="container lnb" style="position: relative">
            <div class="contents_wrap" style="height: 100%;">
                <div class="contents">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <div class="contents_wrap" style="height: calc(100vh - 375 px)">
                        <div style="background: #ffffff;padding: 40px; position: relative">
                                <excel-lookbook-item-multi-component></excel-lookbook-item-multi-component>
                            <div class="mt40" style="text-align: center;">
                                <el-button @click="submitForm()" type="primary">등록</el-button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <page-footer></page-footer>
        </div>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus";
import ExcelLookbookItemMultiComponent from "@/components/excel/ExcelLookbookItemMultiComponent";

export default {
    name: 'LookbookItemExcel',
    components: {
      ExcelLookbookItemMultiComponent,
    },
    mixins: [],
    data() {
        return {}
    },
    mounted() {
    },
    methods: {
        submitForm() {
            EventBus.$emit('writeExcel');
        },
    },
    watch: {}
}
</script>

<style lang="scss" scoped>

</style>
